import scrollManager from '../utils/scrollManager'

export default {
  name: 'header',

  ui: {
    btBurger: '[js-burger]',
    // navWrap: '[js-header-nav-wrap]',
    mainNav: '.nav-primary',
    'togglePanels[]': '[js-header-toggle-panel]',
    'panel[]': '[js-header-panel]',
    // 'toggleSubnavs[]': '[js-header-toggle-subnav]',
    // 'back[]': '[js-header-back]',
    'backPanel[]': '[js-header-back-panel]',
    // 'subnavs[]': '[js-header-subnav]',
  },

  events: [
    {
      target: 'btBurger',
      on: 'click',
      handle (e) {
        e.preventDefault()
        this.ui.btBurger.classList.toggle('is-active')
        this.ui.mainNav.classList.toggle('is-opened')

        // this.ui.navWrap.classList.toggle('is-opened')

        this.isOpen = !this.isOpen

        this.isOpen ? scrollManager.stop() : scrollManager.restart()

        // close actions
        if (!this.isOpen) {
          /* this.ui.subnavs.forEach((subnav) => {
            subnav.classList.remove('is-active')
          }) */
          this.ui.mainNav.classList.remove('is-opened')

          if (document.querySelector('.header-panel.is-active')) {
            document
              .querySelector('.header-panel.is-active')
              .classList.remove('is-active')
          }
        }
      },
    },
    {
      target: 'togglePanels',
      on: 'mouseover', // only on desktop
      handle (e) {
        if (window.innerWidth >= 1024) {
          this.openPanel(e.currentTarget.parentNode)
        }
      },
    },
    {
      target: 'togglePanels',
      on: 'mouseleave', // only on desktop
      handle (e) {
        if (window.innerWidth >= 1024) {
          this.closePanel(e.currentTarget.parentNode)
        }
      },
    },
    {
      target: 'panel',
      on: 'mouseover', // only on desktop
      handle (e) {
        if (window.innerWidth >= 1024) {
          this.openPanel(e.currentTarget.parentNode)
        }
      },
    },
    {
      target: 'panel',
      on: 'mouseleave', // only on desktop
      handle (e) {
        if (window.innerWidth >= 1024) {
          this.closePanel(e.currentTarget.parentNode)
        }
      },
    },
    {
      target: 'panel',
      on: 'click', // only on desktop // to close the panel on click on the transparent dark layer
      handle (e) {
        if (window.innerWidth >= 1024 && e.target.classList.contains('header-panel') && e.currentTarget.classList.contains('header-panel')) {
          this.closePanel(e.currentTarget.parentNode)
        }
      },
    },
    {
      target: 'panel',
      on: 'mouseover', // only on desktop // to close the panel on hover on the transparent dark layer
      handle (e) {
        if (window.innerWidth >= 1024 && e.target.classList.contains('header-panel') && e.currentTarget.classList.contains('header-panel')) {
          this.closePanel(e.currentTarget.parentNode)
        }
      },
    },
    {
      target: 'togglePanels',
      on: 'click',
      handle (e) {
        if (window.innerWidth < 1024) { // only on mobile
          e.preventDefault()
          e.stopPropagation()
          this.openPanel(e.currentTarget.parentNode)
          this.ui.mainNav.classList.remove('is-opened')
        }
      },
    },
    {
      target: 'backPanel', // only on mobile
      on: 'click',
      handle (e) {
        e.target.closest('[js-header-panel]').classList.remove('is-active')
        this.ui.mainNav.classList.toggle('is-opened')
      },
    },
  ],

  componentDidMount () {
    this.body = document.body
    this.header = this.el
    this.headerHeight = this.el.offsetHeight
    this.posYorigin = 0
    this.lastScrollTop = 0
    window.addEventListener('scroll', this.scrollHandler, false)
    this.scrollHandler()

    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        this.headerHeight = this.el.offsetHeight
      }, 300)
    })

    this.body.addEventListener('click', (e) => {
      if (
        window.innerWidth >= 1024 &&
        this.isOpen &&
        // !e.target.classList.contains('header-panel') &&
        !e.target.classList.contains('nav-primary__item') &&
        e.target.closest('.header-panel-inner') === null &&
        !e.target.classList.contains('header-panel-inner')
      ) {
        const activePanel = document.querySelector('.header-panel.is-active')
        if (activePanel) activePanel.classList.remove('is-active')

        if (document.querySelector('.nav-primary__item.is-opened')) {
          document
            .querySelector('.nav-primary__item.is-opened')
            .classList.remove('is-opened')
        }

        scrollManager.restart()
        this.el.classList.remove('is-open')
        this.isOpen = false

        this.closePanel(activePanel)
      }
    })
  },

  scrollHandler () {
    this.st = window.pageYOffset || document.documentElement.scrollTop
    let Ypos = this.posYorigin
    if (this.st > this.lastScrollTop) {
      // downscroll code
      this.header.classList.remove('is-sticky')
      if (this.st > this.headerHeight) Ypos = -this.headerHeight
      else Ypos = -this.st
    } else {
      // upscroll code
      if (this.st > this.headerHeight) {
        this.header.classList.add('is-sticky')
        Ypos = -this.headerHeight
      } else {
        this.header.classList.remove('is-sticky')
        Ypos = -this.st
      }
    }

    if (this.st < this.headerHeight) this.header.classList.add('is-on-top')
    else this.header.classList.remove('is-on-top')
    this.lastScrollTop = this.st <= 0 ? 0 : this.st // For Mobile or negative scrolling

    this.el.style.top = `${Ypos}px`
  },

  openPanel (el) {
    const entry = el.querySelector('.nav-primary__item')
    const panel = el.querySelector('[js-header-panel]')
    entry.classList.add('is-opened')
    panel.classList.add('is-active')
    this.el.classList.add('is-open')
    scrollManager.stop()
  },

  closePanel (el) {
    const entry = el.querySelector('.nav-primary__item')
    const panel = el.querySelector('[js-header-panel]')
    entry.classList.remove('is-opened')
    panel.classList.remove('is-active')
    scrollManager.restart()
    this.el.classList.remove('is-open')
  },
}
